import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Globe, FileText, Zap, Users, ClipboardCheck, Webhook, KeyRound, Activity, BookOpen } from "lucide-react";

const NAV = [
  { to: "/admin/content/destinations", label: "Destinations", icon: Globe },
  { to: "/admin/content/combinations", label: "Combinations", icon: BookOpen },
  { to: "/admin/content/nationalities", label: "Nationalities", icon: Users },
  { to: "/admin/content/posts", label: "Blog Posts", icon: FileText },
  { to: "/admin/content/authors", label: "Authors", icon: Users },
  { to: "/admin/content/review-queue", label: "Review Queue", icon: ClipboardCheck },
  { to: "/admin/content/api-keys", label: "API Keys", icon: KeyRound },
  { to: "/admin/content/webhooks", label: "Webhooks", icon: Webhook },
  { to: "/admin/content/activity", label: "Activity", icon: Activity },
  { to: "/admin/content/settings", label: "Settings", icon: Zap },
];

export default function AdminContentLayout() {
  return (
    <div data-testid="admin-content-layout">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-[#2563eb] font-semibold">Content Studio</div>
        <h1 className="mt-1 font-display font-bold text-3xl text-[#0f1b2d]">Travel Guide & Blog</h1>
        <p className="mt-1 text-[#475569]">Manage the Schengen visa guide, blog posts, automation keys and content webhooks.</p>
      </div>

      <div className="mt-8 flex flex-wrap gap-1 border-b border-[#e2e8f0] pb-1">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            data-testid={`admin-content-tab-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-3.5 py-2 text-sm font-medium rounded-md transition ${
                isActive ? "bg-[#2563eb] text-white" : "text-[#475569] hover:bg-[#f1f5f9]"
              }`
            }
          >
            <n.icon className="w-4 h-4" />{n.label}
          </NavLink>
        ))}
      </div>

      <div className="mt-8">
        <Outlet />
      </div>
    </div>
  );
}
